function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("metadata", {
  id: "metadata876"
}, /*#__PURE__*/React.createElement("useless", null, /*#__PURE__*/React.createElement("useless", {
  useless: ""
}, /*#__PURE__*/React.createElement("useless", null, "image/svg+xml"), /*#__PURE__*/React.createElement("useless", {
  useless: "http://purl.org/dc/dcmitype/StillImage"
}), /*#__PURE__*/React.createElement("useless", null))));

var _ref3 = /*#__PURE__*/React.createElement("defs", {
  id: "defs874"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "layer1"
}, /*#__PURE__*/React.createElement("path", {
  id: "path964-7",
  d: "m -0.389661,53.300057 c 5.023407,10e-7 9.729887,-2.526806 12.330077,-6.789062 2.60019,-4.262256 2.60019,-9.651807 0,-13.914063 C 9.340227,28.334677 4.633747,25.80787 -0.389661,25.80787 v 8.089844 c 2.30083,0 4.363847,1.171379 5.425779,2.912109 1.061931,1.74073 1.061932,3.747551 0,5.488281 -1.061932,1.74073 -3.124949,2.91211 -5.425779,2.91211 z"
}), /*#__PURE__*/React.createElement("rect", {
  ry: 0.00000359872,
  y: 35.331306,
  x: 11.841209,
  height: 7.8125,
  width: 20.721495,
  id: "rect962"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "layer3"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "layer2"
}, /*#__PURE__*/React.createElement("path", {
  id: "path939",
  className: "",
  d: "m 73.821196,6.3352039 c 0,-2.9698113 -2.408454,-5.37826606 -5.378266,-5.37826606 H 36.173333 c -2.969812,0 -5.378266,2.40845476 -5.378266,5.37826606 1.310842,36.0312171 -2.505429,70.0897371 4.93218,71.5185801 9.26529,1.779954 20.728313,2.371458 30.502263,0.812132 3.099878,-0.494552 5.931649,-2.9941 6.461069,-7.40866 C 74.336075,57.536294 74.04779,31.490679 73.821196,6.3352039 Z M 52.308131,70.874398 c -4.455557,0 -8.067399,-3.611843 -8.067399,-8.067399 0,-4.455557 3.611842,-8.067399 8.067399,-8.067399 4.455558,0 8.067399,3.611842 8.067399,8.067399 0,4.455556 -3.611841,8.067399 -8.067399,8.067399 z m 0,-21.513066 c -4.455557,0 -8.067399,-3.611841 -8.067399,-8.067397 0,-4.455558 3.611842,-8.0674 8.067399,-8.0674 4.455558,0 8.067399,3.611842 8.067399,8.0674 0,4.455556 -3.611841,8.067397 -8.067399,8.067397 z m 0,-21.513064 c -4.455557,0 -8.067399,-3.611841 -8.067399,-8.067398 0,-4.455558 3.611842,-8.067399 8.067399,-8.067399 4.455558,0 8.067399,3.611841 8.067399,8.067399 0,4.455557 -3.611841,8.067398 -8.067399,8.067398 z"
}));

var SvgTrafficlight = function SvgTrafficlight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg870",
    role: "presentation",
    "aria-hidden": "true",
    viewBox: "0 0 80 80",
    focusable: "false",
    className: "MuiSvgIcon-root",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrafficlight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trafficlight.e04ea3c8.svg";
export { ForwardRef as ReactComponent };